<template>
  <el-dialog :visible="dialogVisible" width="378px" append-to-body>
    <template #title>
      <div class="title">服用天数超过7天</div>
    </template>
    <template #default>
      <div class="control">
        <el-checkbox-group v-model="checkedRemark">
          <el-checkbox v-for="option in remarkOptions" :label="option" :key="option">{{ option }}</el-checkbox>
        </el-checkbox-group>
        <el-input type="textarea" :rows="3" placeholder="请补充原因" v-model="remark" :maxlength="50"></el-input>
      </div>
    </template>
    <template #footer>
      <el-button class="btn" :class="{ disabled: isDisabled }" type="primary" :disabled="isDisabled" @click="submit">
        提&nbsp;&nbsp;&nbsp;&nbsp;交
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'drugRemarkModal',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkedRemark: [],
      remarkOptions: ['慢病', '长期服用', '医嘱服用'],
      remark: ''
    };
  },
  computed: {
    isDisabled() {
      const { checkedRemark, remark } = this;
      return !checkedRemark.length && !remark;
    }
  },
  methods: {
    submit() {
      const { checkedRemark, remark } = this;
      this.$emit('submit', checkedRemark.join(',') + remark);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  display: flex;
  justify-content: center;
  padding: 24px 0 15px 0;
  font-size: 18px;
  font-weight: bold;
  color: #242424;
  font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
}

/deep/.el-dialog__body {
  display: flex;
  justify-content: center;
  padding: 14px 20px 24px 20px;
  font-size: 14px;
  color: #242424;

  /deep/.el-checkbox-group {
    margin-bottom: 21px;
  }
}

/deep/.el-dialog__footer {
  display: flex;
  justify-content: center;
  padding: 0 0 24px 0;

  .btn {
    width: 132px;

    &.disabled {
      opacity: 0.5;
    }
  }
}
</style>
